export class WhatsappCreateModel {
  key: string;
  chat_dest: string[];
  content_type: string;
  send_in: string;
  content: Object;
}

